export default "__VITE_ASSET__6c9e1f77__"